export class SponsorDealerModel {
  companyName: string;
  companyPhone: string;
  addr1: string;
  addr2: string | null;
  city: string;
  state: string;
  zip: string;
  contactFirstName: string;
  contactLastName: string;
  contactPhone: string;
  contactEmail: string;
  isSubmitted: boolean;
  confirmationMessage: string | null;
  isErrored: boolean;
  isWaiting: boolean;
  distributorName: string | null;
  distributorContactName: string | null;

  constructor(obj: Partial<SponsorDealerModel>) {
    Object.assign(this, obj);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/sponsor-dealer.model.ts